export const InputMainStyle:React.CSSProperties = {
  display: "flex",  
  flexDirection: "column",
  alignItems: "flexStart",
}

export const InputLabelStyle:React.CSSProperties = {
  display: "flex",
  alignItems: "flex-start",
  gap: "4px",
  alignSelf: "stretch",
  color: "#333)",
  fontFeatureSettings: "'ss04' on, 'ss05' on, 'ss03' on, 'ss02' on, 'ss01' on",
  fontFamily: "FS Elliot Pro Regular",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "28px"
}

//TODO: cambiar
export const InputFormatLabelStyle:React.CSSProperties = {
  display: "flex",
  alignItems: "flex-start",
  gap: "4px",
  alignSelf: "stretch",
  color: "#333",
  fontFeatureSettings: "'ss04' on, 'ss05' on, 'ss03' on, 'ss02' on, 'ss01' on",
  fontFamily: "FS Elliot Pro Regular",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "28px"
}

//TODO: cambiar
export const InputSearchStyle:React.CSSProperties = {
  display: "flex",
  height: "48px",
  padding: "10px 16px",
  alignItems: "center",
  gap: "8px",
  alignSelf: "stretch",
  borderRadius: "4px",
  border: "1px solid #616267",
  background: "#FFF",
}

export const InputStyle:React.CSSProperties = {
  display: "flex",
  width: "300px",
  height: "32px",
  padding: "10px 16px",
  alignItems: "center",
  gap: "8px",
  borderRadius: "4px",
  border: "1px solid #616267",
  background: "#FFF",
  color: "#333",
  fontFeatureSettings: "'ss04' on, 'ss05' on, 'ss03' on, 'ss02' on, 'ss01' on",
  fontFamily: "FS Elliot Pro Regular",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "28px",
}

export const InputErrorStyle:React.CSSProperties = {
  display: "flex",
  width: "300px",
  height: "32px",
  padding: "10px 16px",
  alignItems: "center",
  gap: "8px",
  borderRadius: "4px",
  border: "1px solid #C00000",
  background: "#FFF",
  color: "#333",
  fontFeatureSettings: "'ss04' on, 'ss05' on, 'ss03' on, 'ss02' on, 'ss01' on",
  fontFamily: "FS Elliot Pro Regular",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "28px",
}

export const InputLabelErrorMainStyle:React.CSSProperties = {
  display: "flex",
  flexDirection: "row",
  width: "300px",
  alignItems: "center",
  gap: "8px",
  height:"24px"
}

export const InputLabelErrorTextStyle:React.CSSProperties = {
  display: "flex",
  flex: "1 0 0",
  color: "#C00000",
  fontFeatureSettings: "'ss04' on, 'ss05' on, 'ss03' on, 'ss02' on, 'ss01' on",
  fontFamily: "FS Elliot Pro Light",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "24px",
}

export const InputLabelErrorIconStyle:React.CSSProperties = {
  display: "flex",
  width: "20px",
  height: "20px",
  justifyContent: "center",
  alignItems: "center",
  flexShrink: "0",
  alignSelf: "center",
}

export const InputLabelErrorAlertCicleStyle:React.CSSProperties = {
  display: "flex",
  flex: "1 0 0",
  alignSelf: "stretch",
  color:"#C00000"
}

export const InputRequiredStyle:React.CSSProperties = {
  color: "#C00000",
  fontFeatureSettings: "'ss04' on, 'ss05' on, 'ss03' on, 'ss02' on, 'ss01' on",
  fontFamily: "FS Elliot Pro Regular",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "28px",
}

export const BulkPaymentFileUploadStyle:React.CSSProperties = {
  display:"flex",
  flexDirection:"column"
}

export const FileLabelStyle:React.CSSProperties = {
  color: "#333",
  fontFeatureSettings: "'ss04' on, 'ss05' on, 'ss03' on, 'ss02' on, 'ss01' on'",            
  fontFamily: "FS Elliot Pro Regular",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "24px",
}

export const FileNameStyle:React.CSSProperties = {
  flex: "1",
  color: "#333",
  fontFeatureSettings: "'ss04' on, 'ss05' on, 'ss03' on, 'ss02' on, 'ss01' on",  
  fontFamily: "FS Elliot Pro Regular",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "28px",
  marginLeft: "10px"
}

export const FileNameErrorStyle:React.CSSProperties = {
  flex: "1",
  color: "#F33",
  fontFeatureSettings: "'ss04' on, 'ss05' on, 'ss03' on, 'ss02' on, 'ss01' on",  
  fontFamily: "FS Elliot Pro Regular",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "28px",
  marginLeft: "10px"
}